import { AppState } from '../root.reducer';

export const getOrganizationById = (state: AppState, id: string) => state.entities.organization[id];

export const getHubspotCompanySearchResults = (state: AppState) => state.organization.hubspotCompanySearchResults;

export const getOrganizationUsersWithRoles = (state: AppState) => {
  return state.organization.organizationUsers.map((orgUserId) => {
    // this selector needs both
    // fetchOrganizationUsersRequested
    // fetchOrganizationUsersWithRolesRequested
    const orgUser = state.entities.organizationUser[orgUserId];
    const user = state.entities.user[orgUser.userId];
    return {
      ...orgUser,
      user,
    };
  });
};
